type PartnerSwitchRedirectRule = {
  matchPrefix: string
  redirectTo: string
}

const partnerSwitchRedirectRules: PartnerSwitchRedirectRule[] = [{ matchPrefix: '/festival-shop', redirectTo: '/festival-shop' }]

export function getPartnerSwitchRedirect(path: string): string | null {
  const rule = partnerSwitchRedirectRules.find((candidate) => path.startsWith(candidate.matchPrefix))
  return rule ? rule.redirectTo : null
}
